export const DEFAULT_ROUTE = '/component/inbox';
